export default "__VITE_ASSET__068edcc6__"